import React, { useEffect, useState } from "react";
import { siteData } from "../data/mock";
import { ArrowRight, Menu, X } from "lucide-react";

const BrandLogo = () => (
  <a href="#" className="flex items-center gap-2 group">
    <img
      src="https://customer-assets.emergentagent.com/job_career-ai-summit-1/artifacts/xp67b1sj_image.png"
      alt="Epsilon Executive Education"
      className="h-9 md:h-10 w-auto"
    />
  </a>
);

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 border-b hairline ${
        scrolled ? "bg-[#060b17]/85 backdrop-blur-md" : "bg-[#060b17]/40 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-5 sm:px-6 lg:px-10 h-[70px] sm:h-[78px] flex items-center justify-between">
        <BrandLogo />

        <nav className="hidden lg:flex items-center gap-9">
          {siteData.nav.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-[12px] tracking-[0.22em] uppercase text-slate-300 hover:text-white transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <a
          href="#register"
          className="hidden sm:inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-[12px] tracking-[0.22em] uppercase text-[#5EC7F5] border border-[#5EC7F5]/40 hover:bg-[#5EC7F5]/10 transition-colors"
        >
          Reserve My Seat <ArrowRight className="w-3.5 h-3.5" />
        </a>

        <button
          className="lg:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#060b17]/95 border-t hairline">
          <nav className="flex flex-col p-6 gap-4">
            {siteData.nav.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="text-sm tracking-[0.22em] uppercase text-slate-300 hover:text-white"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#register"
              onClick={() => setOpen(false)}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-xs tracking-[0.22em] uppercase text-[#5EC7F5] border border-[#5EC7F5]/40 w-fit"
            >
              Reserve My Seat <ArrowRight className="w-3.5 h-3.5" />
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
